// extracted by mini-css-extract-plugin
export default {"svg":"BookMarkIcon_svg__P0j2m","active":"BookMarkIcon_active__uxCq-"};